import { ActivityTypes } from "./activitytypes.component";
import { ActivityType } from "./activitytype.component";
import { EditActivityType } from "./activitytype.edit.component";
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UIRouterModule } from "@uirouter/angular";
import { activityTypesState, activityTypeState, newActivityTypeState, editActivityTypeState } from "./activitytypes.states";
import { AllMaterialModule } from "../../all-material.components";
import { FlexLayoutModule } from "@angular/flex-layout";
import SharedModule from "../../shared/shared.module";
import { CoreModule } from "../../core/core.module";
import { ColorPickerModule } from 'ngx-color-picker';

let STATES = [activityTypesState, activityTypeState, newActivityTypeState, editActivityTypeState];

import { ConfirmDialog } from "../../shared/confirm-dialog.component";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        AllMaterialModule,
        SharedModule,
        CoreModule,
        FlexLayoutModule,
        UIRouterModule.forChild({ states: STATES }),
        ColorPickerModule
    ],
    declarations: [ActivityTypes, ActivityType, EditActivityType],
    entryComponents: [ConfirmDialog]
})
export class ActivityTypesModule {
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/settings/activitytypes/activitytypes.module.ts